// src/layout/Navbar.js
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BookOpen, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, loading, currentUser, logout } = useAuth();

  // We should always show auth buttons on landing page or when not authenticated
  const shouldShowAuthButtons = 
    location.pathname === '/' || 
    (!location.pathname.includes('/dashboard') && !isAuthenticated);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <nav className="bg-blue-500 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2 no-underline">
              <BookOpen 
                className="h-8 w-8" 
                style={{ 
                  color: 'white', 
                  stroke: 'white', 
                  fill: 'none',
                  strokeWidth: 2 
                }} 
              />
              <span className="text-xl font-bold text-white">StudyAce</span>
            </Link>
          </div>
          
          {/* Always show auth buttons on landing page or when not authenticated */}
          {shouldShowAuthButtons && !loading && (
            <div className="flex items-center space-x-4">
              <Link
                to="/login"
                className="bg-white text-blue-600 hover:bg-gray-100 px-4 py-2 rounded-md font-medium transition-colors no-underline"
              >
                Login
              </Link>
              <Link
                to="/signup"
                className="bg-green-500 hover:bg-green-600 px-4 py-2 rounded-md text-white font-medium transition-colors no-underline"
              >
                Sign Up Free
              </Link>
            </div>
          )}

          {/* Show logout button when authenticated and not on landing page */}
          {isAuthenticated && !shouldShowAuthButtons && !loading && (
            <div className="flex items-center space-x-4">
              {currentUser && (
                <span className="text-white text-sm hidden md:inline">
                  {currentUser.email}
                </span>
              )}
              <button
                onClick={handleLogout}
                className="flex items-center bg-red-500 hover:bg-red-600 px-4 py-2 rounded-md text-white font-medium transition-colors"
              >
                <LogOut className="h-4 w-4 mr-2" />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;